import { Component, Watch, Vue } from 'vue-property-decorator'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import { mapState } from 'vuex';
import { ISession, IDatePicker } from '@/types';
import tableComponent from '../../../components/table/table.vue'

interface IParams {
  serviceId: number;
  startDate?: string;
  endDate?: string;
}

@Component({
  components: {
    DateRangePicker,
    tableComponent
  },
  computed: mapState({

    ServiceId: (state: {session: ISession}) => state.session.serviceId
  })
})

export default class AnalyticsTable extends Vue {

  private ServiceId!: number;

  private namespace: string = '/Analytic';
 
  private pageTitle: string = '';

  private dateStart: string = '';

  private dateEnd: string = '';

  private minDate: string = '';

  private maxDate: string = '';

  private analytics: IDatePicker | null = null;

  private range = {
    startDate: this.dateStart, 
    endDate: this.dateEnd
  };

  private loading: boolean = false;

  private error: boolean = false;

  private get Endpoint () {

    if (this.$router && this.$route.name) {
      
      return this.$route.name;
    }

    return undefined;
  }

  private get Title () {
    
    return this.$t(`navigation.${this.$route.name}`) as string;
  }

  private get TableHeadings () {

    if (this.analytics != null && this.analytics.viewModels) {
   
      const titlesArr: string[] = [],
            columnLength = Object.keys(this.analytics.viewModels[0]).length - 1,
            translations = this.$route.name != 'campaigns' ? 'analytics.titles' : 'analytics.addTitles';

      for (let i = 0; i < columnLength; i++) {

        titlesArr.push((this.$t(translations) as string)[i]);
      } 

      titlesArr.unshift(this.Title);

      return titlesArr;
    }

    return undefined;
  }

  private get DateRange () {

    return this.range;
  }

  private set DateRange (range: any) {

    this.pageTitle = '';
    this.dateStart = '';
    this.dateEnd = '';
    this.minDate = '';
    this.maxDate = '';
    this.analytics = null;

    this.dateStart = this.formatDate(range.startDate);
    this.dateEnd = this.formatDate(range.endDate);

    this.getTableData({
      serviceId: this.ServiceId,
      startDate: this.dateStart,
      endDate: this.dateEnd,
    },`/${this.Endpoint}`);
  }

  mounted () {
  
    if (this.ServiceId != null) {

      this.getTableData({serviceId: this.ServiceId}, `/${this.Endpoint}/DatesRange`);
    }
  }

  private formatDate (date: string) {

    return moment(date).format('YYYY-MM-DD');
  }

  private async fetchTableData (params: IParams, endpoint: string) {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace + endpoint }`, { params });

      if (response.status === 204) {
          
        throw new Error('No data...');
      }

      return response;

    } catch (err) {

      return err;
    }
  }

  private getTableData (params: IParams, endpoint: string) {

    this.fetchTableData(params, endpoint)
      .then(response => {

        if (response.data.startDate === undefined && response.data.endDate === undefined) {
          
          this.minDate = this.formatDate(response.data.minDate);
          this.maxDate = this.formatDate(response.data.maxDate);
          this.dateStart = moment(response.data.maxDate).subtract({ month: 1}).format('YYYY-MM-DD');
          this.dateEnd = moment(response.data.maxDate).format('YYYY-MM-DD');
          
          return this.getTableData({
            serviceId: this.ServiceId,
            startDate: this.dateStart,
            endDate: this.dateEnd,
          }, `/${this.Endpoint}`);
        }
        
        this.analytics = response.data;
      })
      .catch(err => {
        
        this.error = !this.error;
      });
  }

  @Watch('ServiceId')
  updateTableData (next: number, prev: number | null | undefined) {

    if (next != prev && this.ServiceId != null) {

      this.pageTitle = '';
      this.dateStart = '';
      this.dateEnd = '';
      this.minDate = '';
      this.maxDate = '';
      this.analytics = null;
      
      this.getTableData({serviceId: this.ServiceId}, `/${this.Endpoint}/DatesRange`);
    }
  }
}